import React, { createContext, useContext } from 'react';

import type { ShopperPlatformContextConfig } from '@zillow/shopper-platform-config';

import type { getOmpDataQuery } from '../__generated__/graphql';
import type { SharedSessionData } from '../types/genericTypes';
import type { HopsABResult } from '../utils/abs';

export type Platforms = 'mbl' | 'web';
export type DeviceTypes = ShopperPlatformContextConfig['deviceType'];
export interface GlobalStoreState {
    onsiteMessages?: getOmpDataQuery['onsiteMessage'];
    abs: HopsABResult;
    zipcode?: number;
    city?: string;
    platform: Platforms;
    centroid: SharedSessionData['centroid'];
    userSearchContext: 'FOR_SALE' | 'FOR_RENT' | 'SOLD';
    guid: string;
    isNLSEnabled: boolean;
    isNLSDelayedSemanticAcEnabled: boolean;
    isNLSUiUpdatesOnlyEnabled: boolean;
    showNYFairHousingMsg: boolean;
    autocompleteUrl: string;
    isVisualRefreshEnabled: boolean;
    isBuilderCommunityNameSearchEnabled: boolean;
    deviceType: DeviceTypes;
}

const GlobalStoreStateContext = createContext<GlobalStoreState | null>(null);

export function GlobalStoreStateProvider({
    children,
    value,
}: {
    children: React.ReactNode;
    value: GlobalStoreState;
}) {
    return (
        <GlobalStoreStateContext.Provider value={value}>
            {children}
        </GlobalStoreStateContext.Provider>
    );
}

export function useGlobalStoreState() {
    const context = useContext(GlobalStoreStateContext);

    if (context === null) {
        throw new Error('useGlobalStoreState must be used within a GlobalStoreStateProvider');
    }

    return context;
}
